import { Enum } from "../base/enum";

const markEnum = new Enum(
  ["absent", "insufficient", "sufficient", "discrete", "good", "excellent"],
  [0, 1, 2, 3, 4, 5],
  ["Absent", "Insufficient", "Sufficient", "Discrete", "Good", "Excellent"]
);

export { markEnum };
